(function () {
  'use strict';

  var SELECTOR = '[data-model-recs]';

  /* ─── Entry point ─────────────────────────────────────────────────── */

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  injectSpinnerStyles();

  /* ─── Setup ───────────────────────────────────────────────────────── */

  async function setup(container) {
    var model = parseModel(container.dataset.model);
    if (!model) return;

    var currentHandle = container.dataset.currentHandle;
    var limit = parseInt(container.dataset.limit, 10) || 5;

    var yearRange = container.dataset.yearRange || '';
    var yrMatch = yearRange.match(/(\d{4})[–\-](\d{4})/) || yearRange.match(/(\d{4})/);
    var yearStart = yrMatch ? yrMatch[1] : null;
    var yearEnd   = yrMatch ? (yrMatch[2] || yrMatch[1]) : null;

    var products = await fetchProducts(model, 20);

    var filtered = products.filter(function (p) { return p.handle !== currentHandle; });

    if (yearStart) {
      filtered.sort(function (a, b) {
        return yearScore(b.title, yearStart, yearEnd) - yearScore(a.title, yearStart, yearEnd);
      });
    }

    filtered = filtered.slice(0, limit);

    if (!filtered.length) {
      container.hidden = true;
      return;
    }

    filtered = await enrichWithVariants(filtered);
    render(container, filtered);
  }

  /* ─── Helpers ─────────────────────────────────────────────────────── */

  function localePrefix() {
    var m = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    return m ? '/' + m[1] : '';
  }

  function parseModel(raw) {
    if (!raw) return '';
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed[0] || '';
      if (typeof parsed === 'string') return parsed;
    } catch (e) {}
    return raw;
  }

  function yearScore(title, yearStart, yearEnd) {
    if (!yearStart) return 1;
    var m = title.match(/\((\d{4})[–\-](\d{4})\)/) || title.match(/\((\d{4})\)/);
    if (!m) return 1;

    var pStart = parseInt(m[1], 10);
    var pEnd   = m[2] ? parseInt(m[2], 10) : pStart;
    var cStart = parseInt(yearStart, 10);
    var cEnd   = parseInt(yearEnd || yearStart, 10);

    if (pStart === cStart && pEnd === cEnd) return 4;
    if (pStart <= cEnd && pEnd >= cStart)   return 3;
    var dist = Math.min(Math.abs(pStart - cEnd), Math.abs(cStart - pEnd));
    if (dist <= 2) return 2;
    if (dist <= 5) return 1;
    return 0;
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function fmtPrice(priceStr) {
    var num = parseFloat(priceStr);
    if (isNaN(num)) return '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    var locale = (document.documentElement.lang || 'pl').slice(0, 2);
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency,
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      }).format(num);
    } catch (e) {
      return num.toFixed(2) + '\u00a0' + currency;
    }
  }

  /* ─── API ─────────────────────────────────────────────────────────── */

  async function fetchProducts(query, limit) {
    try {
      var url = localePrefix() + '/search/suggest.json?q=' + encodeURIComponent(query) +
                '&resources[type]=product&resources[limit]=' + limit;
      var res = await fetch(url);
      if (!res.ok) {
        console.warn('[gp-mrec] suggest fetch failed, status:', res.status);
        return [];
      }
      var json = await res.json();
      return (json.resources && json.resources.results && json.resources.results.products) || [];
    } catch (e) {
      console.error('[gp-mrec] suggest fetch error:', e);
      return [];
    }
  }

  async function enrichWithVariants(products) {
    return Promise.all(products.map(async function (product) {
      try {
        var handle = product.handle || (product.url || '').replace(/.*\/products\//, '').split('?')[0];
        if (!handle) return product;
        var res = await fetch(localePrefix() + '/products/' + handle + '.js');
        if (!res.ok) return product;
        var data = await res.json();
        return Object.assign({}, product, { variants: data.variants || [] });
      } catch (e) {
        return product;
      }
    }));
  }

  /* ─── Rendering ───────────────────────────────────────────────────── */

  function buildItem(product, index, btnLabel) {
    var variant = (product.variants || [])[0];
    var price   = fmtPrice(product.price_min || product.price);
    var imgUrl  = product.featured_image ? product.featured_image.url : '';
    var imgHtml = imgUrl
      ? '<img src="' + esc(imgUrl) + '&width=200" alt="' + esc(product.title) + '" width="100" height="100" loading="lazy">'
      : '';
    var sepClass = index > 0 ? ' gp-mrec__item--sep' : '';
    var label    = esc(btnLabel || 'Dodaj do koszyka');
    var btnHtml  = variant
      ? '<button class="gp-mrec__btn" type="button" data-vid="' + esc(String(variant.id)) + '" data-url="' + esc(product.url) + '">' + label + '</button>'
      : '<a href="' + esc(product.url) + '" class="gp-mrec__btn">' + label + '</a>';

    return (
      '<div class="gp-mrec__item' + sepClass + '">' +
        '<a href="' + esc(product.url) + '" class="gp-mrec__img-wrap" tabindex="-1" aria-hidden="true">' +
          '<div class="gp-mrec__img-bg">' + imgHtml + '</div>' +
        '</a>' +
        '<div class="gp-mrec__info">' +
          '<a href="' + esc(product.url) + '" class="gp-mrec__name">' + esc(product.title) + '</a>' +
          '<div class="gp-mrec__bottom">' +
            '<span class="gp-mrec__price">' + price + '</span>' +
            btnHtml +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function render(container, products) {
    var list = container.querySelector('.gp-mrec__list');
    if (!list) return;
    var btnLabel = container.dataset.btnLabel || '';
    list.innerHTML = products.map(function (p, i) { return buildItem(p, i, btnLabel); }).join('');
    list.querySelectorAll('.gp-mrec__btn[data-vid]').forEach(function (btn) {
      btn.addEventListener('click', onAddToCart);
    });
  }

  /* ─── Add to cart ─────────────────────────────────────────────────── */

  async function onAddToCart(e) {
    var btn  = e.currentTarget;
    var vid  = btn.dataset.vid;
    var url  = btn.dataset.url;
    var orig = btn.innerHTML;

    btn.disabled = true;
    btn.innerHTML = '<span class="gp-mrec__spinner"></span>';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
      });

      if (res.ok) {
        updateCartBubble();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.publish === 'function') {
          window.publish('cart-update', { source: 'model-recommendations' });
        }
        resetBtn(btn, orig);
      } else {
        console.error('[gp-mrec] cart/add failed — status:', res.status, 'vid:', vid);
        resetBtn(btn, orig);
        window.location.href = url;
      }
    } catch (ex) {
      console.error('[gp-mrec] cart/add exception:', ex, 'vid:', vid);
      resetBtn(btn, orig);
      window.location.href = url;
    }
  }

  function resetBtn(btn, orig) {
    btn.innerHTML = orig;
    btn.disabled  = false;
  }

  function updateCartBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!bubble) return;
        var count = cart.item_count;
        var spans = bubble.querySelectorAll('span');
        if (spans[0]) spans[0].textContent = count;
        if (spans[1]) spans[1].textContent = count + ' ' + spans[1].textContent.replace(/^\d+\s*/, '');
        bubble.style.display = count > 0 ? '' : 'none';
      })
      .catch(function () {});
  }

  /* ─── Spinner styles ──────────────────────────────────────────────── */

  function injectSpinnerStyles() {
    if (document.getElementById('gp-mrec-spinner-styles')) return;
    var style = document.createElement('style');
    style.id = 'gp-mrec-spinner-styles';
    style.textContent =
      '@keyframes gp-mrec-spin{to{transform:rotate(360deg)}}' +
      '.gp-mrec__spinner{display:inline-block;width:15px;height:15px;' +
      'border:2px solid currentColor;border-top-color:transparent;' +
      'border-radius:50%;animation:gp-mrec-spin .65s linear infinite;vertical-align:middle}';
    document.head.appendChild(style);
  }
})();
